import React from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';
import { motion } from '@/lib/motion';
import { useWhatsAppNumber, getWhatsAppUrl } from '../hooks/useWhatsAppNumber';

/**
 * Floating "one-click WhatsApp" launcher. Sits above the AI chat and the
 * ChatWidget so all three CTAs stack neatly on the bottom-right rail.
 *
 * Number is fetched from /api/site-config (admin-configurable) with a
 * hardcoded fallback of the current business line so the button never
 * "breaks" if the API is slow.
 */
export const WhatsAppButton = () => {
  const whatsappNumber = useWhatsAppNumber();
  const prefilled = encodeURIComponent(
    "Hi IHGIND, I'd like to talk about an architectural metalwork project."
  );
  const href = `${getWhatsAppUrl(whatsappNumber)}?text=${prefilled}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-40 right-4 sm:bottom-44 sm:right-6 z-40 flex items-center gap-2 h-14 sm:h-14 pl-3 pr-4 bg-[#25D366] text-white rounded-full shadow-xl hover:shadow-2xl hover:bg-[#1EBE5A] transition-all group"
      aria-label={`Chat with IHGIND on WhatsApp at ${whatsappNumber}`}
      title="Chat on WhatsApp"
      data-testid="whatsapp-button"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.6, type: 'spring' }}
    >
      <span className="relative flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 bg-white/15 rounded-full">
        <WhatsappLogo weight="fill" className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
        <span className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-white border-2 border-[#25D366] animate-pulse" />
      </span>
      <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap max-w-0 group-hover:max-w-[140px] overflow-hidden transition-all duration-300">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
